import React from "react";
import { Link } from "react-router-dom";

/**
 * Componente para mostrar el segundo nivel de los servicios, estas se cargan a través de iteraciones tomando la 
 * información desde el archivo .src/data/data.json -> "Services"
 *
 * @component
 * @example
 * 
 * "Services": [
    {
      "id": 0,
      "img": "/img/services/BuyerPersona.webp",
      "img_mob": "/img/services/BuyerPersona_mob.webp",
      "imgFooter": "/img/services/BuyerPersona.webp",
      "name": "Buyer Persona",
      "text": "Construimos perfiles de audiencia detallados para impulsar estrategias de marketing personalizadas.",
      "url": "/servicios/buyerPersona"
    }
  ]
 * 
 */

export const ServicesHome = (props) => {
    const [width, setWidth] = React.useState(window.innerWidth);
    const breakpoint = 620;
  
    React.useEffect(() => {
        /* Inside of a "useEffect" hook add an event listener that updates
        the "width" state variable when the window size changes */
        window.addEventListener("resize", () => setWidth(window.innerWidth));
  
        /* passing an empty array as the dependencies of the effect will cause this
        effect to only run when the component mounts, and not each time it updates.
        We only want the listener to be added once */
    }, []);

    const chunk = (arr, size) =>
    Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
        arr.slice(i * size, i * size + size)
    );

  return (
    <div id="service-home" className="text-center">
      <div className="container-fluid padding-fluid" style={ width < breakpoint ? {paddingLeft: '15px', paddingRight: '15px'} : { } }>
        <div className="col-md-8 col-md-offset-2 section-title" >
        <h2><span className="title">Servicios</span></h2>
        </div>
        <div className="row">
            {props.data ? chunk(props.data, (width < breakpoint ? 2 : 3)).map((e, index) => {
                return (
                  <div key={`dv0${index}`} className="col-md-12 col-xs-12" style={ width < breakpoint ? {paddingLeft: '0px', paddingRight: '0px'} : { } }>
                    
                    {e.map((d, i) => {
                      return (
                        <div key={`dv1${i}`} className={d.id !== 4 ? "col-md-4 col-xs-6 text-center" : "col-md-8 col-xs-12 text-center"} >
                          <div key={`dv2${i}`}>
                                <Link key={`lnk1${i}`} to={d.url}>
                                    {/* <img className="img-responsive" key={`img${i}`} alt={d.name} src={d.img} /> */}
                                    <img className="img-responsive" key={`img${i}`} alt={d.name} src={width < breakpoint ? d.img_mob : d.img } />
                                </Link>
                                <div key={`dv3${i}`} className="col-md-12 titleContainer">
                                    <div key={`dv4${i}`} className="col-md-10 col-sm-6 col-xs-10 titleContainer">
                                        <Link key={`lnk2${i}`} to={d.url}>
                                            <p key={`p${i}`}>{d.name}</p>
                                        </Link>
                                    </div>
                                    <div key={`dv5${i}`} className="col-md-2 col-sm-6 col-xs-2 dvTitle">
                                        <Link key={`lnk3${i}`} to={d.url}>
                                            <img alt="ram" src="img/Arrow.png" className="imgTitle"></img>
                                        </Link>
                                    </div>
                                </div>
                          </div>
                    </div>
                      );
                    })}
                  </div>
                );
            }) : ''}
        </div>
      </div>
    </div>
  );
};
